export const FUNNEL_CHART_CONFIG: Highcharts.Options = {
  chart: {
    type: "funnel",
  },
  title: {
    text: "",
    align: "left",
  },
  credits: {
    enabled: false,
  },
  legend: {
    enabled: false,
  },
  plotOptions: {
    funnel: {
      width: "80%",
      neckWidth: "30%",
      neckHeight: "25%",
      center: ["40%", "50%"],
      dataLabels: {
        enabled: true,
        softConnector: true,
      },
    },
  },
  series: [],
  exporting: {
    enabled: true,
    sourceWidth: 1400,
    sourceHeight: 600,
    scale: 2,
    chartOptions: {
      chart: {
        marginRight: 30,
      },
    },
    buttons: {
      contextButton: {
        align: "right",
        verticalAlign: "top",
        y: -43,
        x: -30,
      },
    },
  },
  accessibility: {
    enabled: false,
  },
};
